import { render, staticRenderFns } from "./Dadata.vue?vue&type=template&id=3c107b78&scoped=true"
import script from "./Dadata.vue?vue&type=script&lang=js"
export * from "./Dadata.vue?vue&type=script&lang=js"
import style0 from "./Dadata.vue?vue&type=style&index=0&id=3c107b78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c107b78",
  null
  
)

export default component.exports